export type TypeaheadBlurAction = 'clear' | 'revert' | 'noop';

/** What a single-value typeahead field should do on blur when no suggestion was picked. */
export const resolveTypeaheadBlurAction = (
  typedValue: string,
  committedLabel: string,
): TypeaheadBlurAction => {
  if (typedValue === committedLabel) return 'noop';
  return typedValue === '' ? 'clear' : 'revert';
};
